import { Input, Select } from 'antd';
import React from 'react';
import { dspxGetChildrens } from '../../../../../../helpers/dspx-utils';
import useStreetQuery from '../../../api/useStreetQuery';
import useHouseQuery from '../../../api/useHouseQuery';
import { useSelector } from 'react-redux';
import { compactMultiSelectTagProps } from '../../primitives/selectTagProps';

const selectStreet = (state) => state.filterStore.valueAddrStreet;
const selectHouse = (state) => state.filterStore.valueAddrBuilding;

const SelectStreetHouse = ({ onChangeStreet, onChangeHouse }) => {
  const streetValue = useSelector(selectStreet);
  const houseValue = useSelector(selectHouse);

  const { data: streets = [], isFetching: isFetchingStreets } =
    useStreetQuery();
  const { data: houses, isFetching: isFetchingHouses } = useHouseQuery(
    streetValue?.[0],
    { enabled: !!streetValue?.length }
  );

  return (
    <Input.Group compact>
      <Select
        {...compactMultiSelectTagProps}
        mode="multiple"
        dropdownMatchSelectWidth={false}
        defaultActiveFirstOption={false}
        allowClear={true}
        style={{ width: 234 }}
        placeholder="Улица"
        notFoundContent="нет данных"
        value={streetValue}
        onChange={onChangeStreet}
        optionLabelProp="label"
        optionFilterProp="searchtext"
        disabled={isFetchingStreets}
        loading={isFetchingStreets}
      >
        {dspxGetChildrens(streets)}
      </Select>
      <Select
        {...compactMultiSelectTagProps}
        mode="multiple"
        defaultActiveFirstOption={false}
        allowClear={true}
        style={{ width: 234 }}
        notFoundContent="нет данных"
        placeholder="Дом"
        optionFilterProp="searchtext"
        value={houseValue}
        onChange={onChangeHouse}
        disabled={isFetchingHouses}
        loading={isFetchingHouses}
      >
        {dspxGetChildrens(houses)}
      </Select>
    </Input.Group>
  );
};

export default SelectStreetHouse;
